import React from 'react';
import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone, Youtube, MessageCircle } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { ChevronUp } from "lucide-react";
import { motion } from "framer-motion"; // ✅ required for animation
import ScrollTopButton from "../components/ScrollTopButton";


const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img
              src="/img/mbw.png"
              alt="MBW Techimpex"
              className="h-12 w-auto"
            />
            <p className="text-sm leading-relaxed">
              Empowering Digital Growth Since 2004
            </p>
            <p className="text-sm text-gray-400">
              22+ years of excellence in web development and digital marketing.
            </p>
          </div>



          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => navigate('/')}
                  className="hover:text-blue-400 transition-colors text-sm"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/about')}
                  className="hover:text-blue-400 transition-colors text-sm"
                >
                  About
                </button>
              </li>
              {/* <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="hover:text-blue-400 transition-colors text-sm"
                >
                  Services
                </button>
              </li> */}
              <li>
                <button
                  onClick={() => navigate('/portfolio')}
                  className="hover:text-blue-400 transition-colors text-sm"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/blog')}
                  className="hover:text-blue-400 transition-colors text-sm"
                >
                  Blog
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/contact')}
                  className="hover:text-blue-400 transition-colors text-sm"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => navigate('/domain-registration')}
                  className="hover:text-blue-400 transition-colors text-left"
                >
                  Domain Name Registration
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/web-hosting')}
                  className="hover:text-blue-400 transition-colors text-left"
                >
                  Web Hosting
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/website-development')}
                  className="hover:text-blue-400 transition-colors text-left"
                >
                  Website Development
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/digital-marketing')}
                  className="hover:text-blue-400 transition-colors text-left"
                >
                  Digital Marketing
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/social-media')}
                  className="hover:text-blue-400 transition-colors text-left"
                >
                  SEO & SMM
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/professional-email')}
                  className="hover:text-blue-400 transition-colors text-left"
                >
                  Professional Business Emails
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/security')}
                  className="hover:text-blue-400 transition-colors text-left"
                >
                  Website & Domain Security
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/mobile-app-development')}
                  className="hover:text-blue-400 transition-colors text-left"
                >
                  Mobile App Development
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <MapPin className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <span> MBW Techimpex Pvt Ltd<br />
                  15 F, Valmiki Street,<br />
                  Chennai - 600 017<br />
                  Tamil Nadu ,India.</span>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <span> +91 44 4260 5227</span>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
                <span>contact@mbwit.net</span>
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex gap-3 mt-6">
              <a
                href="https://www.linkedin.com/company/mbw-techimpex-p-ltd"
                target="_blank"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-blue-600 flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://www.facebook.com/MBWTechimpexPvtLtd"
                target="_blank"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-blue-600 flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/mbwtech"
                target="_blank"
                className="w-10 h-10 rounded-full bg-gray-800 hover:bg-blue-600 flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>

            </div>
          </div>
        </div>



        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              Copyright © 2026 MBW Techimpex Pvt Ltd. All rights reserved.
            </p>
            <p className="text-sm text-gray-400">
              Empowering Digital Growth Since 2004
            </p>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <ScrollTopButton />



    </footer>
  );
};

export default Footer;